import { createAuthContext } from '@react-keycloak/core';
export var reactKeycloakWebContext = createAuthContext();
export var ReactKeycloakWebContextConsumer = reactKeycloakWebContext.Consumer;
//# sourceMappingURL=context.js.map